export default __webpack_public_path__ + "static/media/seattle.3f0492f6.png";